import {
  IframePidgetSettings,
  useIframePidgetInstance,
  useIframePidgetLocation,
  useIframePidgetSettings
} from "@workspace/utils-react";
import React, { PropsWithChildren, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { IframeContext } from "../../../index";

type PageProps = {
  title: string;
};

function IframePageTracker({ title }: { title: string }) {
  const location = useLocation();
  const settings = useIframePidgetSettings<IframePidgetSettings>();
  const instance = useIframePidgetInstance();
  const locationHook = useIframePidgetLocation(settings?.workspaceUrl);
  const prevUrlRef = useRef<string>("");

  useEffect(() => {
    if (!settings || !instance || !locationHook) {
      return;
    }

    const baseUrl = window.location.href;
    // const separator = baseUrl.includes("?") ? "&" : "?";
    const currentUrl = `${baseUrl}`;
    if (prevUrlRef.current === currentUrl) {
      return;
    }

    prevUrlRef.current = currentUrl;

    try {
      locationHook.setIframePidgetLocation({
        url: currentUrl,
        title: { breadcrumb: [title] }
      });
    } catch (error) {
      console.debug("Failed to set iframe pidget location:", error);
    }
  }, [location, title, settings, instance, locationHook]);

  return null;
}

export function Page(props: PropsWithChildren<PageProps>): React.JSX.Element {
  const isInIframe = useContext(IframeContext);

  return (
    <>
      {isInIframe && <IframePageTracker title={props.title} />}
      {props.children}
    </>
  );
}
